import styled from 'styled-components';
import Progress from '@clds/progress';

export const StyledProgressSpinner = styled(Progress.Logo)`
  width: 15%;
  max-width: 130px;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  height: 100%;
`;

export const ProgressSpinner = () => (
  <Wrapper data-testid="progress-spinner">
    <StyledProgressSpinner size="xl" />
  </Wrapper>
);
